export const getNavItemUrl = (url: string): string => {
  if (url?.startsWith("http")) {
    return url;
  }
  const urlWithoutLocale = url?.split("/").slice(2).join("/");
  return `/${urlWithoutLocale}`;
};
